import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M12 4a7 7 0 0 0-6.708 5H6a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4a9 9 0 1 1 18 0v4a2 2 0 0 1-1.059 1.765A5 5 0 0 1 15 21h-3.5a1.5 1.5 0 0 1 0-3H13a2 2 0 0 1 1.732 1H15a3 3 0 0 0 2.83-2.007A2 2 0 0 1 16 15v-4a2 2 0 0 1 2-2h.708A7 7 0 0 0 12 4"
    }
  )
);
var SvgHeadsetFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var HeadsetFilled_default = SvgHeadsetFilled;

export { HeadsetFilled_default as default };
